'use client';

import { Toaster as SonnerToaster } from 'sonner';

import { useBreakpoints } from '@/hooks/use-breakpoints';

export function Toaster() {
  const isMobile = useBreakpoints('md');

  return (
    <SonnerToaster
      position={isMobile ? 'bottom-center' : 'bottom-right'}
      swipeDirections={['top', 'right', 'bottom', 'left']}
      closeButton={!isMobile}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'group pointer-events-auto relative flex w-full items-start gap-3 overflow-hidden rounded-md border border-input bg-white p-6 pr-8 text-sm text-foreground shadow-lg data-[type=success]:border-transparent data-[type=success]:bg-success data-[type=error]:border-destructive data-[type=error]:bg-destructive data-[type=error]:text-destructive-foreground',
          title: 'text-sm font-semibold',
          description: 'whitespace-pre-line text-sm opacity-90',
          closeButton: 'absolute left-auto right-2 top-2 rounded-md border-none bg-transparent p-1 text-current opacity-0 transition-opacity focus:opacity-100 group-hover:opacity-100',
        },
      }}
    />
  );
}
